app.controller('CIFFIN-CTRL', ['$scope', '$rootScope', '$routeParams', 'uibDateParser', 'deviceDetector',
    '$uibModal', '$http', '$window', '$location', '$timeout', 'Upload', '$q', '$filter', function ($scope, $rootScope, $routeParams, uibDateParser, deviceDetector,
    $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {

        $scope.stage = 4;
        $scope.CIFInvestor = {};
        $scope.ktpPhoto = '';
        $scope.device = deviceDetector;
        $scope.append = '';

        $scope.showSubmit = false;
        $scope.showCam = true;
        $scope.showCapture = true;
        $scope.tmpPhoto = "";

        $scope.counter = 6;

        $scope.series5 = [];
        //$scope.series7 = [];

        $rootScope.myAppUtility = {
            isMobile: function isMobile() {
                return window && window.matchMedia("(max-width: 767px)").matches;
            }
        };

        $scope.takeCamera = function () {
            //$scope.statusCamera = 'true';
            //if (!$rootScope.myAppUtility.isMobile()) {
            //    swal({
            //        title: 'Push notifications',
            //        text: 'Mohon untuk menggunakan kamera handphone',
            //        imageUrl: 'img/erdikha/from_erdikha/LoginSelamatDatang.png',
            //        imageAlt: 'E-KTP',
            //        width: '400px',
            //        animation: false
            //    });
            //    return;

            //}

            $scope.showCapture = false;
            $scope.counter = 3;
            $scope.showSubmit = false;
            $scope.showCam = true;
            var mytimeout = $timeout($scope.onTimeout, 1000);
        }

        $scope.onTimeout = function () {
            $scope.counter--;
            if ($scope.counter > 0) {
                var mytimeout = $timeout($scope.onTimeout, 1000);
            }
            else {
                console.log('capturing...', $scope.stage);
                $scope.$broadcast('ngWebcam_capture');
                //alert("Time is up!");
            }
        }



        $scope.reset = function () {
            $scope.counter = 5;
            var mytimeout = $timeout($scope.onTimeout, 1000);
        }

        $scope.switchCam = function () {
            console.log($scope.camfacing);
            if ($scope.camfacing == 'env') {
                console.log('cam1');
                $scope.$broadcast('ngWebcam_camUsr');
                $scope.camfacing = 'usr'
            }
            else {
                console.log('cam1');
                $scope.$broadcast('ngWebcam_camEnv');
                $scope.camfacing = 'env'
            }

            console.log($scope.camfacing);
        }


        $scope.camfacing = 'env';
        $scope.ktpPhoto = '';

        $scope.KTPconfig = {
            //viewerWidth: 300,
            //viewerHeight: 350,
            outputWidth: 1080,
            outputHeight: 1280,
            delay: 5,
            shots: 3,
            countdown: 0,
            flashFallbackUrl: 'vendors/webcamjs/webcam.swf',
            shutterUrl: 'shutter.mp3',
            flashNotDetectedText: 'Camera not found or use Chrome Browser'
        };

        $scope.KTPonCaptureComplete = function (src) {
            console.log('capturecomplete', $scope.stage);
            $scope.counter = 1;

            //if ($scope.stage == 5) {
            //    console.log("CAPTURE COMPLETE STAGE 5");
            //    $scope.series7 = [];
            //    for (var i = 0; i < src.length; i++) {
            //        $scope.series7.push(src[i]);
            //    }
            //    //$scope.series7 = src;
            //    $scope.submit();

            //}

            if ($scope.stage == 4) {
                console.log("CAPTURE COMPLETE STAGE 4");
                $scope.counter = 6;

                $scope.series5 = [];
                for (var i = 0; i < src.length; i++) {
                    $scope.series5.push(src[i]);
                }

                $scope.showSubmit = true;
                $scope.showCam = false;
                $scope.showCapture = true;
                console.log('poto', $scope.series5);
                $scope.tmpPhoto = $scope.series5[0];
                //    //$scope.submit();
                //    //$scope.changeStage(5);
            }


            //var el = document.getElementById('result');
            //var img = document.createElement('img');
            //img.src = src[$scope.KTPconfig.shots - 1];
            //img.width = 240;
            //img.height = 180;
            //el.appendChild(img);
        };


        $scope.KTPonLive = function (err) {
            console.log('live');
        };


        $scope.KTPonError = function (err) {
            //$log.error('webcamController.onError : ', err);

            //var SWALtranslate = $scope.SWALtranslate("kycdevice");

            //$rootScope.GlobalAlert('warning', SWALtranslate.title, SWALtranslate.message);

            Swal.fire('Error', 'Mohon maaf anda tidak dapat melanjutkan proses selanjutnya karena perangkat anda tidak terdeteksi kamera', 'error').then(function () {
                $window.location.href = "#/login";
                $window.location.reload();
            });
            console.log('err', err);
        };

        $scope.KTPonLoad = function () {
            // $log.info('ktp.onLoad');
            console.log('load');
        };

        $scope.KTPcapture = function () {
            $scope.$broadcast('ngWebcam_capture');
        };

        $scope.KTPon = function () {
            $scope.$broadcast('ngWebcam_on');
        };

        $scope.KTPoff = function () {
            $scope.$broadcast('ngWebcam_off');
            $scope.captureButtonEnable = false;
        };

        $scope.KTPremove = function () {
            $scope.ktpPhoto = '';
        }

        $scope.takeCamera2 = function () {
            //$scope.series5 = [];
            //$scope.tmpPhoto = '';
            //$scope.showCam = true;
            //$scope.showSubmit = false;
            $window.location.reload();

        }



        $scope.openCamera = function () {
            let message = 'KTP';
            let url = 'ModalCamera.html';
            let ctrl = 'CameraController';


            if ($scope.device.isMobile()) {
                url = 'ModalBrowse.html';
                ctrl = 'BrowseController';
                $scope.append = 'data:image/png;base64,';
            }

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: url,
                controller: ctrl,
                size: 'md',
                resolve: {
                    items: function () {
                        return message;
                    }
                }
            });
            modalInstance.result.then(function (resolvedResponse) {
                //console.log('ktp',resolvedResponse);
                if (resolvedResponse) {
                    $scope.ktpPhoto = resolvedResponse;
                }
            }, function () { });
        };

        $scope.KTPremove = function () {
            $scope.ktpPhoto = '';
        };


        var allPromise = $q.all([
            $scope.retrieveSessions()

        ]);




        $scope.changeStage = function (newstage) {
            $scope.stage = newstage;

            if ($scope.stage == 4) {
                $scope.$broadcast('ngWebcam_camUsr');
                $scope.camfacing = 'usr'
                //Swal.fire({
                //    imageUrl: 'img/verification/step1.png',
                //    imageAlt: 'E-KTP',
                //    background: '#1c252c',
                //    width: '600px',
                //    allowEscapeKey: false,
                //    allowOutsideClick: false,
                //    animation: false,
                //    onOpen: () => {
                //        swal.showLoading()
                //        setTimeout(() => { swal.hideLoading() }, 3000)
                //    },
                //}).then((result) => {
                //    if (!result.dismiss) {
                //        //$scope.counter = 6;
                //        //var mytimeout = $timeout($scope.onTimeout, 1000);
                //    }
                //})


            }

            //if ($scope.stage == 5) {
            //    $scope.$broadcast('ngWebcam_restart');
            //    $scope.$broadcast('ngWebcam_camUsr');
            //    $scope.camfacing = 'usr'
            //    Swal.fire({
            //        imageUrl: 'img/verification/step2.png',
            //        imageAlt: 'E-KTP',
            //        background: '#1c252c',
            //        width: '600px',
            //        allowEscapeKey: false,
            //        allowOutsideClick: false,
            //        animation: false,
            //        onOpen: () => {
            //            swal.showLoading()
            //            setTimeout(() => { swal.hideLoading() }, 3000)
            //        },
            //    }).then((result) => {
            //        if (!result.dismiss) {
            //            $scope.counter = 6;
            //            var mytimeout = $timeout($scope.onTimeout, 1000);
            //            //console.log('user read the important message')
            //        }
            //    })


            //}
        }


        allPromise.then(function () {

            $http({
                method: 'GET',
                url: 'service/client.svc/getCIF',
            }).then(function (data) {
                if (data.data.d != null) {
                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;
                    $scope.CIFInvestor.Stage = 5;

                } // END IF data.data.d
            }, function (error) { });
        });



        $scope.submit = function () {
            $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
            $http({
                method: 'POST',
                url: 'service/client.svc/ImageVerification',
                data:
                {
                    imageData: {
                        series5: $scope.series5,
                        //series7: $scope.series7,
                    }
                }
            }).then(function (data) {
                if (data.data.d.result == true) {
                    Swal.fire('success', 'Permohonan pembukaan rekening efek Anda telah kami terima. Silahkan cek email', 'success').then(function () {
                        $window.location.href = "#/dashboard";
                    });
                }
                else {
                    Swal.fire('Failed', data.data.d.message, 'Failed').then(function () {
                        $window.location.reload();
                    });
                }

            }, function (error) {
                Swal.fire('Error', 'error - Please check your connection' + error, 'error');
            });
        }

        $scope.logOff = function () {
            $http({
                method: 'POST',
                url: 'service/client.svc/logOff',
            }).then(function (data) {
                console.log(data);
                if (data.data.d == true) {
                    $window.location.href = "#/login";
                    $window.location.reload();
                }
            }, function (error) { })
        };



    }]);
